import * as React from 'react';
import Selector, { ISelectorData } from './Selector';
import './FilterReport.scss';
import { Producer, SummaryProducer } from '../Models/Report';

export interface IFilterReportProps {
	producers: Producer[];
	onChangeProducer: (value: string | number) => void;
	onChangeBranch: (value: string | number) => void;
	selected?: SummaryProducer | Producer;
	ignoreFilter?: boolean;
	disabled?: boolean;
}

const sort = (a: Producer, b: Producer) => {
	const namea = a.name.toLowerCase();
	const nameb = b.name.toLowerCase();
	if (namea > nameb) {
		return -1;
	}
	if (namea > nameb) {
		return 1;
	}
	return 0;
}

const FilterReport = (props: IFilterReportProps) => {
	const [isReady, setReady] = React.useState(true);
	let data = props.selected &&  props.selected!.branchs ? props.selected!.branchs.filter(b => (props.ignoreFilter && b.id > 0) || b.total > 0).map(b => ({ label: b.name, value: b.id })) : [];
	if (!isReady) {
		data = [];
	}
	const onChangeProd = (value: string | number) => {
		setReady(false);
		props.onChangeProducer(value);
		setTimeout(() => {
			setReady(true);
		}, 200);
	}
	return (<div className="FilterReport">
		{props.producers.length !== 1 && <Selector disabled={props.disabled} onChange={onChangeProd} placeholder="Seleccionar Minera" data={props.producers.sort(sort).reverse().map(p => ({ label: p.name.toUpperCase(), value: p.id }) as ISelectorData)} />}
		<Selector disabled={props.disabled} onChange={props.onChangeBranch} placeholder="Seleccionar Faena" data={data} />
	</div>)
}

export default FilterReport;
